import { render, staticRenderFns } from "./RecordPurchaseRequisition.vue?vue&type=template&id=1d3f1658&"
import script from "./RecordPurchaseRequisition.vue?vue&type=script&lang=js&"
export * from "./RecordPurchaseRequisition.vue?vue&type=script&lang=js&"
import style0 from "./RecordPurchaseRequisition.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports